module.exports = __webpack_public_path__ + "static/img/18100C_1_C_20210324_LC.4548ee0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/18100C_1_C_20210324_LC.png
// module id = zt8W
// module chunks = 0